import {OrderType, PlaceApi} from "../../../services/Api/types";
import StorageStore from "../../../services/Common/Storage/storageStore";

export const getSortedPlacesByDistance = (places: PlaceApi[]) => {
    return [...places].sort((a, b) => {
        if (a.distance === undefined) return 1;
        if (b.distance === undefined) return -1;
        return a.distance - b.distance;
    });
};

export const calcPlaceDistance = (place: PlaceApi) => {
    if (!place.distance) return undefined;

    return Math.round((place.distance + Number.EPSILON) * 100) / 100
}

export const getProperPlaceLink = (place: PlaceApi) => {
    let link = place.domain.replace(`${StorageStore.storeDomain}/`, "/");

    if (!link.startsWith('/')) {
        link = '/' + link;
    }

    return link;
}

const anyPlaceSupportsOrderType = (places: PlaceApi[], orderType: OrderType) => {
    return (places || []).some(place => place.types.includes(orderType));
}

export const getMultistoreOrderTypes = (places: PlaceApi[]) => {
    const orderTypes: OrderType[] = [];

    if (anyPlaceSupportsOrderType(places, OrderType.DELIVERY)) orderTypes.push(OrderType.DELIVERY);
    if (anyPlaceSupportsOrderType(places, OrderType.PICK_UP)) orderTypes.push(OrderType.PICK_UP);
    if (anyPlaceSupportsOrderType(places, OrderType.DINE_IN)) orderTypes.push(OrderType.DINE_IN);
    if (anyPlaceSupportsOrderType(places, OrderType.ROOM_SERVICE)) orderTypes.push(OrderType.ROOM_SERVICE);

    return orderTypes;
}